import { render, staticRenderFns } from "./ftc-modal.vue?vue&type=template&id=d74d6232"
import script from "./ftc-modal.vue?vue&type=script&lang=js"
export * from "./ftc-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports